// dependencies
import React, { useEffect, useState } from 'react';
import { injectIntl, Translate } from '../../localization/index';

// local
import './PreLander.scss';

export default function ToggleDisclaimer({showHolder}){
  const [isPercent, setPercent] = useState(0);

  useEffect(() => {
    var c = 0;

    function countUp() {
      c++;

      if (c > 100) {
        c = 100;
        clearInterval(starter);
        showHolder();
      } else {
        setPercent(c);
      }
    }

    var starter = setInterval(countUp, 20);
  }, []);
  
  return(

    <div className="PreLander">
      <h1>
        <Translate id="waitAMoment" defaultMessage="Wait a moment" />
      </h1>
     <svg
       xmlns="http://www.w3.org/2000/svg"
       fillRule="evenodd"
       strokeLinejoin="round"
       strokeMiterlimit="2"
       clipRule="evenodd"
       viewBox="0 0 286 255"
       className='cog-loader'
     >
       <g  className="SmallCog">
       <path
        
         fill="#008ce1"
         d="M278.717 189.195a57.803 57.803 0 00-6.313 0c.224 4.135-1.151 7.643-4.125 10.525a48.129 48.129 0 00-10.204 2.734c-4.017-1.008-6.962-3.359-8.835-7.053a58.19 58.19 0 00-5.467 3.157c2.262 3.469 2.826 7.194 1.691 11.177a48.147 48.147 0 00-7.47 7.47c-3.983 1.135-7.709.572-11.178-1.691a58.324 58.324 0 00-3.156 5.468c3.693 1.873 6.044 4.818 7.053 8.834a48.124 48.124 0 00-2.735 10.205c-2.881 2.974-6.39 4.349-10.525 4.124a58.327 58.327 0 000 6.314c4.135-.225 7.644 1.15 10.525 4.124a48.131 48.131 0 002.735 10.204c-1.009 4.017-3.36 6.962-7.053 8.835a58.18 58.18 0 003.156 5.467c3.469-2.262 7.195-2.825 11.178-1.691a48.11 48.11 0 007.47 7.471c1.135 3.982.571 7.708-1.691 11.177a58.41 58.41 0 005.467 3.157c1.873-3.694 4.818-6.045 8.835-7.053a48.129 48.129 0 0010.204 2.734c2.974 2.882 4.349 6.39 4.125 10.525 2.103.114 4.21.114 6.313 0-.225-4.135 1.15-7.643 4.124-10.525a48.122 48.122 0 0010.205-2.734c4.016 1.008 6.961 3.359 8.834 7.053a58.426 58.426 0 005.468-3.157c-2.262-3.469-2.826-7.195-1.691-11.177a48.153 48.153 0 007.47-7.471c3.983-1.134 7.709-.571 11.177 1.691a57.97 57.97 0 003.157-5.467c-3.693-1.873-6.044-4.818-7.053-8.835a48.129 48.129 0 002.734-10.204c2.882-2.974 6.39-4.349 10.526-4.124a58.327 58.327 0 000-6.314c-4.136.225-7.644-1.15-10.526-4.124a48.122 48.122 0 00-2.734-10.205c1.009-4.016 3.36-6.961 7.053-8.834a58.112 58.112 0 00-3.157-5.468c-3.468 2.263-7.194 2.826-11.177 1.691a48.19 48.19 0 00-7.47-7.47c-1.135-3.983-.571-7.708 1.691-11.177a58.205 58.205 0 00-5.468-3.157c-1.873 3.694-4.818 6.045-8.834 7.053a48.122 48.122 0 00-10.205-2.734c-2.974-2.882-4.349-6.39-4.124-10.525zm-3.157 33.08c13.813 0 25.028 11.214 25.028 25.027s-11.215 25.027-25.028 25.027c-13.813 0-25.027-11.214-25.027-25.027s11.214-25.027 25.027-25.027z"
         transform="translate(-347.215 -302.076) scale(1.59736)"
       ></path>
       </g>
       <g className="BigCog">
       <path
         
         fill="#008ce1"
         d="M277.978 189.159a58.177 58.177 0 00-4.835 0l-3.94 9.852a48.718 48.718 0 00-12.282 3.291l-8.339-6.562a58.542 58.542 0 00-4.186 2.417l1.513 10.503a48.691 48.691 0 00-8.991 8.991l-10.502-1.514a57.81 57.81 0 00-2.417 4.187l6.562 8.338a48.687 48.687 0 00-3.291 12.282l-9.852 3.941a58.153 58.153 0 000 4.834l9.852 3.94a48.664 48.664 0 003.291 12.282l-6.562 8.339a58.026 58.026 0 002.417 4.187l10.502-1.514a48.691 48.691 0 008.991 8.991l-1.513 10.502a58.176 58.176 0 004.186 2.418l8.339-6.562a48.716 48.716 0 0012.282 3.29l3.94 9.853c1.611.067 3.224.067 4.835 0l3.94-9.853a48.727 48.727 0 0012.282-3.29l8.338 6.562a57.98 57.98 0 004.187-2.418l-1.514-10.502a48.691 48.691 0 008.991-8.991l10.503 1.514a58.402 58.402 0 002.417-4.187l-6.562-8.339a48.706 48.706 0 003.291-12.282l9.852-3.94a58.153 58.153 0 000-4.834l-9.852-3.941a48.729 48.729 0 00-3.291-12.282l6.562-8.338a58.184 58.184 0 00-2.417-4.187l-10.503 1.514a48.691 48.691 0 00-8.991-8.991l1.514-10.503a58.344 58.344 0 00-4.187-2.417l-8.338 6.562a48.729 48.729 0 00-12.282-3.291l-3.94-9.852zm-2.418 33.116c13.813 0 25.028 11.214 25.028 25.027s-11.215 25.027-25.028 25.027c-13.813 0-25.027-11.214-25.027-25.027s11.214-25.027 25.027-25.027z"
         transform="translate(-94.71 -94.325) scale(1.14029)"
       ></path>
 </g>
 
     </svg>
 
     <div className='bar'>
       <div className='progress'></div>
     </div>
 
     <p><Translate id="loading" defaultMessage="Processing Content" />... <span>{isPercent + "%"}</span></p>
 
   </div>

  )


}

